import { ShippingMethod, ShippingMethodsResponse } from '@/types/commercetools';

// A cart within this range of a free-shipping threshold shows the "almost there" banner.
const FREE_SHIPPING_BANNER_THRESHOLD_CENTS = 10000; // 100€

function getCheapestShippingMethod(shippingMethods: ShippingMethod[]): ShippingMethod | undefined {
  return shippingMethods.reduce<ShippingMethod | undefined>(
    (cheapest, method) =>
      !cheapest || method.price.centAmount < cheapest.price.centAmount ? method : cheapest,
    undefined
  );
}

function getFreeShippingScore(shippingMethod: ShippingMethod): number | undefined {
  return shippingMethod.cartScoreShippingRates
    .filter((rate) => rate.price.centAmount === 0)
    .reduce<
      number | undefined
    >((lowestScore, rate) => (lowestScore === undefined || rate.score < lowestScore ? rate.score : lowestScore), undefined);
}

// Returns the cents remaining to reach free shipping when the banner should show, or undefined
// when it shouldn't (no free-shipping tier, or the cart isn't within the "almost there" window).
export function getFreeShippingBannerRemainder(
  shippingMethodsResponse: ShippingMethodsResponse | null | undefined,
  basketItemValueCentAmount: number
): number | undefined {
  const cheapestMethod = getCheapestShippingMethod(shippingMethodsResponse?.shippingMethods ?? []);
  if (!cheapestMethod) return undefined;

  const freeShippingScore = getFreeShippingScore(cheapestMethod);
  if (freeShippingScore === undefined) return undefined;

  const difference = freeShippingScore - basketItemValueCentAmount;
  return difference > 0 && difference < FREE_SHIPPING_BANNER_THRESHOLD_CENTS
    ? difference
    : undefined;
}
